const navData = () => ([
  // {
  //   label: 'Telegram',
  //   icon: 'icon-send',
  //   size: { width: 24, height: 24 },
  //   link: 'telegram',
  // },
  {
    label: 'Twitter',
    icon: 'icon-logo-twitter',
    size: { width: 24, height: 24 },
    link: 'twitter',
  },
  {
    label: 'Facebook',
    icon: 'icon-logo-fb-simple',
    size: { width: 24, height: 24 },
    link: 'facebook',
  },
  {
    label: 'Instagram',
    icon: 'icon-logo-instagram',
    size: { width: 24, height: 24 },
    link: 'instagram',
  },
  {
    label: 'Linkedin',
    icon: 'icon-logo-linkedin',
    size: { width: 24, height: 24 },
    link: 'linkedin',
  },
  {
    label: 'Youtube',
    icon: 'icon-logo-youtube',
    size: { width: 24, height: 24 },
    link: 'youtube',
  },
]);

export default navData;



// WEBPACK FOOTER //
// ../src/components/Footer/Social/getSocialData.js